import _ from 'lodash';

const hasFontTags = (textNode) => {
  return !_.isEmpty(textNode.getElementsByTagName('font'));
};

const replaceFontTags = (textNode) => {
  // getElementsByTagName returns the elements in the order they appear
  // in the tree. We reverse the array so it handles nested elements first
  // https://developer.mozilla.org/en-US/docs/Web/API/Element/getElementsByTagName
  const fontNodes = [...textNode.getElementsByTagName('font')];
  const orderedFontNodes = fontNodes.reverse();

  orderedFontNodes
    .forEach((fontNode) => {
      const parentElm = fontNode.parentElement;
      const newSpan = document.createElement('span');
      const spanStyle = newSpan.style;

      spanStyle.color = fontNode.color;
      spanStyle.fontFamily = fontNode.face;

      newSpan.innerHTML = fontNode.innerHTML;

      parentElm.replaceChild(newSpan, fontNode);
    });

  return textNode.innerHTML;
};

export default {
  hasFontTags,
  replaceFontTags
};


// WEBPACK FOOTER //
// ./src/ui/inline-text/text-cleaner.js